'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bomb';
var width = 512;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M48 304c0 88.4 71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2l-10.3-28.7L361.4 208 304 150.6l-13.1 13.1-28.7-10.3c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160zm32 0c0-70.7 57.3-128 128-128l0 48c-44.2 0-80 35.8-80 80l-48 0z', 'M432 0l26.7 53.3L512 80l-53.3 26.7L432 160l-26.7-53.3L352 80l53.3-26.7L432 0zM290.9 163.7l-28.7-10.3c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2l-10.3-28.7L361.4 208 304 150.6l-13.1 13.1zm47-47l57.4 57.4 11.3 11.3L429.3 208l-22.6 22.6-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7l22.6 22.6 11.3 11.3zM208 224c-44.2 0-80 35.8-80 80l-48 0c0-70.7 57.3-128 128-128l0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;